export type ApiObject = {
    label: string;
    specUrl: string;
    serverUrl: string;
    env: "hfw-prod" | "hfw-demo" | "apr-prod"
};

export default function apis(): ApiObject[] {
    const hfwDemo: ApiObject[] = [
        {
            label: "[v2] Planning",
            specUrl: "https://api-pp.hifivework.com/v2/planning/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v1] White label",
            specUrl: "https://wl-pp.hifivework.com/v1/hfwWhiteLabel/openapi",
            serverUrl: "https://wl-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] Payslip",
            specUrl: "https://api-pp.hifivework.com/v2/payslip/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] Oauth",
            specUrl: "https://api-pp.hifivework.com/v2/oauth/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] Expense report",
            specUrl: "https://api-pp.hifivework.com/v2/expensereport/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] Profile",
            specUrl: "https://api-pp.hifivework.com/v2/profile/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] Billing",
            specUrl: "https://api-pp.hifivework.com/v2/hfw-billing/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        /*{
            label: "[v2] Admin bitbucket",
            specUrl: "https://api-pp.hifivework.com/v2/bitbucket/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },*/
        {
            label: "[v2] Modules manager",
            specUrl: "https://api-pp.hifivework.com/v2/module-manager/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] CK Billing",
            specUrl: "https://api-pp.hifivework.com/v2/billing/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] End of month",
            specUrl: "https://api-pp.hifivework.com/v2/end-month/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] Modules",
            specUrl: "https://api-pp.hifivework.com/v2/modules/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] Chartered Accountant",
            specUrl: "https://api-pp.hifivework.com/v2/chartered-accountant/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] Notification",
            specUrl: "https://api-pp.hifivework.com/v2/notification/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        },
        {
            label: "[v2] Shuttle sheet",
            specUrl: "https://api-pp.hifivework.com/v2/shuttle-sheet/openapi",
            serverUrl: "https://api-pp.hifivework.com",
            env: "hfw-demo"
        }
    ]

    const hfwProd: ApiObject[] = [
        {
            label: "[v1] White label",
            specUrl: "https://wl.hifivework.com/v1/hfwWhiteLabel/openapi",
            serverUrl: "https://wl.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] Payslip",
            specUrl: "https://api.hifivework.com/v2/payslip/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] Planning",
            specUrl: "https://api.hifivework.com/v2/planning/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] Oauth",
            specUrl: "https://api.hifivework.com/v2/oauth/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] Expense report",
            specUrl: "https://api.hifivework.com/v2/expensereport/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] Profile",
            specUrl: "https://api.hifivework.com/v2/profile/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        /*{
            label: "[v2] Billing",
            specUrl: "https://api.hifivework.com/v2/hfw-billing/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] Admin bitbucket",
            specUrl: "https://api.hifivework.com/v2/bitbucket/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },*/
        {
            label: "[v2] Modules manager",
            specUrl: "https://api.hifivework.com/v2/module-manager/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] CK Billing",
            specUrl: "https://api.hifivework.com/v2/billing/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] End of month",
            specUrl: "https://api.hifivework.com/v2/end-month/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] Modules",
            specUrl: "https://api.hifivework.com/v2/modules/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] Chartered Accountant",
            specUrl: "https://api.hifivework.com/v2/chartered-accountant/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] Notification",
            specUrl: "https://api.hifivework.com/v2/notification/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        },
        {
            label: "[v2] Shuttle sheet",
            specUrl: "https://api.hifivework.com/v2/shuttle-sheet/openapi",
            serverUrl: "https://api.hifivework.com",
            env: "hfw-prod"
        }
    ]

    const aprProd: ApiObject[] = [
        {
            label: "[v2] Oauth",
            specUrl: "https://api.africapaierh.com/v2/oauth/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] Payslip",
            specUrl: "https://api.africapaierh.com/v2/payslip/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] Planning",
            specUrl: "https://api.africapaierh.com/v2/planning/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] Expense report",
            specUrl: "https://api.africapaierh.com/v2/expensereport/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] Profile",
            specUrl: "https://api.africapaierh.com/v2/profile/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] Billing",
            specUrl: "https://api.africapaierh.com/v2/apr-billing/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] Modules manager",
            specUrl: "https://api.africapaierh.com/v2/module-manager/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] CK Billing",
            specUrl: "https://api.africapaierh.com/v2/billing/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] End of month",
            specUrl: "https://api.africapaierh.com/v2/end-month/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] Modules",
            specUrl: "https://api.africapaierh.com/v2/modules/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] Chartered Accountant",
            specUrl: "https://api.africapaierh.com/v2/chartered-accountant/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] Notification",
            specUrl: "https://api.africapaierh.com/v2/notification/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        },
        {
            label: "[v2] Shuttle sheet",
            specUrl: "https://api.africapaierh.com/v2/shuttle-sheet/openapi",
            serverUrl: "https://api.africapaierh.com",
            env: "apr-prod"
        }
    ]

    return hfwDemo.concat(hfwProd).concat(aprProd)
}
